//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';
import UrlData from '../Utils/url-data';
import Dispatcher from '../dispatcher';
import axios from 'axios';
import TrackJs from '../Utils/trackjs-interface';


export default {
  getProducts() {
    return api('products').noauth().get().dispatch(Constants.GET_PRODUCTS_SUCCESS);
  },

  getProductsBySkus(skus:string[], allowInvisible?:boolean = false) {
    const url = `products?skus=${skus.join(',')}&allowInvisible=${allowInvisible.toString()}`;

    const action = Constants.GET_PRODUCTS_BY_SKUS_SUCCESS;
    return api(url).noauth().get().dispatch(action);
  },

  getProductReviews() {
    const query = `query
    {
      productReviewSummaries {
        productSku
        total
        rating
      }
    }
    `;
    const urlBase = UrlData.getEngineApiUrl();
    const config = {
      method: 'post',
      url: `${urlBase}/graphql`,
      data: {query},
    };
    return axios(config)
      .then(response => {
        const {productReviewSummaries} = response.data.data;
        if (productReviewSummaries) {
          Dispatcher.dispatchAction(
            Constants.GET_PRODUCT_REVIEW_SUMMARIES_SUCCESS,
            productReviewSummaries
          );
        }
        return {response};
      })
      .catch(error => {
        TrackJs.console.debug('getProductReviews error: ' + JSON.stringify(error));
        // eslint-disable-next-line promise/no-return-wrap
        return Promise.reject({error});
      });
  },
};
